import React, { FC } from 'react';
import Rating from '../../../common/components/Rating';

import styles from './ReviewCategory.module.scss';

export type ReviewCategoryProps = {
  rating: number;
  title: string;
};

const ReviewCategory: FC<ReviewCategoryProps> = ({ rating, title }) => (
  <li className={styles.root}>
    <h4 className={styles.title}>
      {title}
    </h4>
    <Rating
      rating={rating}
      withTextRating
      feature="aggregate"
    />
  </li>
);

export default ReviewCategory;
